import { render, staticRenderFns } from "./AccessTokenCreate.vue?vue&type=template&id=707f05ea"
import script from "./AccessTokenCreate.vue?vue&type=script&lang=js"
export * from "./AccessTokenCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports